import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.MyAccountScheduleResponse | undefined,
  (params: vp.MyAccountScheduleRequest) => void,
  () => void,
  (params: vp.MyAccountScheduleRequest) => Promise<vp.MyAccountScheduleResponse>,
];

function usePostWithdrawMyAccountSchedule({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.MyAccountScheduleRequest>();
  const [response, setResponse] = useState<vp.MyAccountScheduleResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.MyAccountScheduleRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postWithdrawMyAccountSchedule(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.MyAccountScheduleRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
    async (requestParams: vp.MyAccountScheduleRequest) => {
      const res = await api.postWithdrawMyAccountSchedule(requestParams, source);
      return res;
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostWithdrawMyAccountSchedule);
